export default __webpack_public_path__ + "static/media/Jenny_Timur-181_websize.f470f329.jpg";